import React from 'react'
import {BsLinkedin, BsGithub, BsTwitter} from 'react-icons/bs'
import './social.css'

const Social = () => {
  return (
    <div className='social'>
        <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><BsLinkedin/></a>
        <a href="https://github.com" target="_blank" rel="noopener noreferrer"><BsGithub/></a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><BsTwitter/></a>

    </div>
  )
}

export default Social